import { render, staticRenderFns } from "./JinLiXiangLabelDialog.vue?vue&type=template&id=96b92742&scoped=true"
import script from "./JinLiXiangLabelDialog.vue?vue&type=script&lang=js"
export * from "./JinLiXiangLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./JinLiXiangLabelDialog.vue?vue&type=style&index=0&id=96b92742&prod&scoped=true&lang=css"
import style1 from "./JinLiXiangLabelDialog.vue?vue&type=style&index=1&id=96b92742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b92742",
  null
  
)

export default component.exports